import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

export const Grid = ({ children }) => (
	<div className={styles.grid}>{children}</div>
);

Grid.propTypes = {
	children: PropTypes.node
};

export const Row = ({ children }) => (
	<div className={styles.row}>{children}</div>
);

Row.propTypes = {
	children: PropTypes.node
};

export const Block = ({ children, orientation }) => (
	<div className={cx(styles.block, styles[orientation])}>{children}</div>
);

Block.propTypes = {
	children: PropTypes.node,
	orientation: PropTypes.oneOf(['portrait', 'landscape'])
};

export default Grid;
